/* eslint-disable */
export default {
  state: {},
  mutations: {},
  actions: {
    getBillData({ commit }, payload) {
      return new Promise((resolve, reject) => {
        this.axios
          .get("/locations/" + payload.locationId + "/billings", { params: payload.params })
          .then(res => {
            resolve(res);
          })
          .catch(err => {
            reject(err);
          });
      });
    },
  },
  getters: {}
};
